import { Avatar, Button, Form, Input, Select } from "antd";
import axios from "axios";
import { debounce } from "lodash";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { getTimeConverter, timeMap } from "../../utils";
import { authenticateToken } from "../../utils/auth";
import { responseNotification } from "../../utils/notify";
const { Option } = Select;

const AddRestrictProduct = ({ visibleData, onCloseMethod }: any) => {
  const [error, setError] = useState("");
  const [type, setType] = useState("JC_MART");
  const [durationUnit, setDurationUnit] = useState();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [productData, setProductData] = useState(undefined);
  const [barCode, setBarCode] = useState("");
  const [productBarcodeOptions, setProductBarcodeOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [singleProductInfo, setSingleProductInfo] = useState({
    loading: false,
    data: null,
  });

  const getProductByBarcodeOptions = useCallback(
    async (bCode) => {
      setProductBarcodeOptions({ loading: false, list: [] });

      setProductBarcodeOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

      const res = await axios.get(
        `${encodedUri}/admin/product/search?` +
          `limit=${16}` +
          `&isDeleted=${false}` +
          (bCode ? `&barCode=${bCode}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setProductBarcodeOptions({
        loading: false,
        list: res?.data?.keys?.map((product: { name: any; barCode: any }) => {
          return {
            value: product?.barCode,
            label: product?.name,
          };
        }),
      });
    },
    [type]
  );

  const fetchProductDetails = useCallback((getProductBarCode) => {
    if (getProductBarCode) {
      try {
        setSingleProductInfo({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_CATALOG_READER_API}/global-product/details?barCode=${getProductBarCode}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setSingleProductInfo({
                loading: false,
                data: data?.data?.product,
              });
            } else {
              setSingleProductInfo({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setSingleProductInfo({ loading: false, data: null });

            console.log(err);
          });
      } catch (error) {
        setSingleProductInfo({ loading: false, data: null });

        console.log(error, "error");
      }
    }
  }, []);

  const onSubmit = async (data: any) => {
    setLoading(true);
    var duration = moment.duration(
      data.durationInMinutes,
      durationUnit || "day"
    );

    const readyData = data && {
      barCode: data.barCode,
      durationInMinutes: duration.asMinutes(),
      quantity: data.quantity,
      image: singleProductInfo?.data?.productImage,
      name: singleProductInfo?.data?.name,
    };

    if (productData) {
      await fetch(`${process.env.REACT_APP_ORDER_API}/product-restrict`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...readyData,
          id: productData?.id,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Product Updated Successfully", "success");
            form.resetFields();
            if (onCloseMethod) {
              onCloseMethod();
            }
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else {
      await fetch(`${process.env.REACT_APP_ORDER_API}/product-restrict`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(readyData),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Product Restricted Successfully", "success");
            form.resetFields();
            if (onCloseMethod) {
              onCloseMethod();
            }
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  const fetchRef = useRef(null);
  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }

      if (value) {
        if (field === "productByBarcode") getProductByBarcodeOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [getProductByBarcodeOptions]);

  useEffect(() => {
    if (visibleData) {
      setProductData(visibleData);
      setBarCode(visibleData?.barCode);
    }
  }, [visibleData]);

  useEffect(() => {
    if (barCode) {
      fetchProductDetails(barCode);
    }
  }, [barCode, fetchProductDetails]);

  useEffect(() => {
    if (productData) {
      form.resetFields(Object.keys(visibleData));
    }
  }, [productData, form, visibleData]);

  // **********************************
  const selectAfter = (
    <Select
      defaultValue={getTimeConverter(productData?.durationInMinutes).label}
      onSelect={(val) => setDurationUnit(val)}
      className="text-capitalize"
    >
      {Object.keys(timeMap).map((item, i) => (
        <Option value={item} key={i} cla>
          {item}
        </Option>
      ))}
    </Select>
  );
  // **********************************

  return (
    <div className="add-product drawer-toggle-wrapper">
      <div className="drawer-toggle-inner-wrapper">
        <Avatar
          src={singleProductInfo?.data?.productImage}
          size={100}
          shape="square"
          className="mb-4"
        />
        <Form
          name="control-hooks"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          className="ant-form ant-form-vertical "
          onFinish={onSubmit}
          form={form} // like ref
          layout="vertical"
          initialValues={{
            ...productData,
            durationInMinutes: getTimeConverter(productData?.durationInMinutes)
              .value,
          }}
        >
          <Form.Item
            hasFeedback
            label="Select Product"
            rules={[
              {
                required: true,
                message: "Product is Required!",
              },
            ]}
            name="barCode"
            style={{ minWidth: "98%" }}
          >
            <Select
              showSearch
              placeholder="Select Product"
              optionFilterProp="children"
              onChange={(val) => setBarCode(val)}
              onSearch={(val) => {
                handleSearch(val, "productByBarcode");
              }}
              filterOption={(input, option) =>
                option.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              allowClear
            >
              {productBarcodeOptions?.list?.map((product, i) => (
                <Option value={product.value} key={i}>
                  {product.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Duration"
            rules={[
              {
                required: true,
                message: "Duration is Required!",
              },
            ]}
            name="durationInMinutes"
          >
            <Input
              id="durationInMinutes"
              type="number"
              placeholder="Enter Duration"
              addonAfter={selectAfter}
            />
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Quantity"
            rules={[
              {
                required: true,
                message: "Quantity is Required!",
              },
            ]}
            name="quantity"
          >
            <Input id="quantity" type="number" placeholder="Enter Quantity" />
          </Form.Item>

          <div className="buttons-container">
            <Button
              disabled={loading || !!error}
              loading={(loading ? "loading" : undefined) as any}
              type="primary"
              htmlType="submit"
              className="add-submit-btn text-center mr-2"
            >
              Submit
            </Button>
            <Button
              type="ghost"
              htmlType="button"
              onClick={() => {
                form?.resetFields();
                setBarCode("");
              }}
              className="reset-submit-btn text-center mr-2"
            >
              Reset
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AddRestrictProduct;
